import { render, staticRenderFns } from "./sdkList.vue?vue&type=template&id=193fea7b&scoped=true&"
import script from "./sdkList.vue?vue&type=script&lang=js&"
export * from "./sdkList.vue?vue&type=script&lang=js&"
import style0 from "./sdkList.vue?vue&type=style&index=0&id=193fea7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193fea7b",
  null
  
)

export default component.exports